
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useContext, useEffect } from "react";
import { useRouter } from "next/router";
import Head from "next/head";
import { GetServerSidePropsContext } from "next";
import useTranslation from "next-translate/useTranslation";
import Layout from "../components/Layout";
import { MetaContext } from "../components/meta";
import SitterProfile from "../components/sitterprofile/SitterProfile";
import Placeholder from "../components/sitterprofile/Placeholder";
import { GetCaregiverDocument, GetCurrentUserIdDocument, useGetCaregiverQuery, useGetCurrentUserIdQuery } from "../generated/graphql";
import { trackOwnerSitterProfileVisited } from "../lib/event-tracking";
import { addApolloState, initializeApollo } from "../lib/apolloClient";
import CustomError from "./_error";
function SitterProfilePage(props: {
    errorCode?: number;
}) {
    const { t } = useTranslation("sitterprofile");
    const { url } = useContext(MetaContext);
    const router = useRouter();
    const { query } = router;
    const { id, title } = query;
    const { loading, data, fetchMore } = useGetCaregiverQuery({
        // if id is 0, send slug as id (for dogley redirects)
        variables: { id: (id === "0" ? title : id) as string },
        notifyOnNetworkStatusChange: true,
        partialRefetch: true
    });
    const { data: userData } = useGetCurrentUserIdQuery();
    const currentUser = userData && userData.currentUser;
    const caregiver = data && data.caregiver;
    const canonical = url.replace(/[0-9]+-.+/g, caregiver?.slug);
    const minServicePrice = caregiver?.services && caregiver?.services?.length > 0
        ? Math.min(...caregiver?.services?.map(s => s.price!))
        : 10;
    // TODO: add Google Enhance Ecommerce tracking
    useEffect(() => {
        caregiver && trackOwnerSitterProfileVisited(caregiver);
    }, [caregiver]);
    // Sitter deleted
    if (props.errorCode === 410) {
        return <CustomError statusCode={410}/>;
    }
    return (<Layout title={t("title", {
            headline: caregiver?.cleanHeadline!,
            name: caregiver?.name!,
            city: caregiver?.city?.name!,
            minServicePrice: minServicePrice
        })} description={t("description", {
            name: caregiver?.name!,
            city: caregiver?.city?.name!,
            minServicePrice: minServicePrice,
            description: `${caregiver?.caregiverDescription?.substring(0, 55)}...`
        })} displayFooterAreas metaImage={caregiver?.photos && caregiver?.photos?.length > 0
            ? caregiver?.photos[0].slider
            : undefined}>
      {caregiver && (<Head>
          <meta property="al:ios:url" content={`gudog://caregiverprofile/${caregiver.id}`}/>
          <meta property="al:android:url" content={`gudog://caregiverprofile/${caregiver.id}`}/>
          <link rel="canonical" href={canonical}/>
        </Head>)}

      {!caregiver && !currentUser ? (<Placeholder />) : (<SitterProfile query={query} caregiver={caregiver} currentUser={currentUser} loading={loading} fetchMore={fetchMore} showOtherCities/>)}
    </Layout>);
}
const getServerSideProps = async (context: GetServerSidePropsContext) => {
    const { query, locale, req, res } = context;
    const apolloClient = initializeApollo(locale || "en", req);
    // if id is 0, send slug as id (for dogley redirects)
    const variables = { ...query };
    if (query.id === "0") {
        variables.id = query.title;
    }
    const result = await Promise.all([
        apolloClient.query({
            query: GetCaregiverDocument,
            variables,
            errorPolicy: "all"
        }),
        apolloClient.query({
            query: GetCurrentUserIdDocument
        })
    ]);
    // sitter permanently deleted
    if (!result[0].data.caregiver &&
        result[0].errors &&
        result[0].errors[0]["extensions"].code === "DELETED") {
        res.statusCode = 410;
        return {
            props: {
                errorCode: 410
            }
        };
    }
    // not found or don't belong to current country
    if (!result[0].data.caregiver ||
        result[0].data.caregiver.country.locale != locale) {
        return {
            notFound: true
        };
    }
    // dogley redirect
    if (variables.id === variables.title) {
        const urlWithId = req.url?.replace("0-", `${result[0].data.caregiver.id}-`);
        return {
            redirect: {
                destination: urlWithId,
                statusCode: 301
            }
        };
    }
    // redirect to sitter slug
    if (`${query.id}-${query.title}` != result[0].data.caregiver.slug) {
        return {
            redirect: {
                destination: result[0].data.caregiver.slug,
                statusCode: 301
            }
        };
    }
    return addApolloState(apolloClient, {
        props: {
            locale
        }
    });
};
export default SitterProfilePage;

    async function __Next_Translate__getServerSideProps__1985553be54__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/sitterprofile',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1985553be54__ as getServerSideProps }
  